<template lang="pug">
.container.grid-lg.my-2.py-2
  load-manager(:status="status")
  fieldset(:disabled="loading")
    form(@submit.prevent="save" v-if='current')
      .panel
        .panel-header
          .h5 Editar Cadastro Restrito
        .panel-body.columns
          form-group.column.col-12(:label="'cadastro_protegido.cadastro' | tModel" :validation="$v.form.cadastro_id")
            cadastro-picker(v-model="$v.form.cadastro_id.$model" disabled)
          form-group.column.col-12(:label="'cadastro_protegido.doc_modelo' | tModel" :validation="$v.form.doc_modelo_id")
            doc-modelo-picker(v-model="$v.form.doc_modelo_id.$model")
          form-group.column.col-3.col-sm-12(:label="'cadastro_protegido.inicia_em' | tModel" :validation="$v.form.inicia_em")
            datepicker(v-model="$v.form.inicia_em.$model")
          form-group.column.col-3.col-sm-12(:label="'cadastro_protegido.termina_em' | tModel" :validation="$v.form.termina_em")
            datepicker(v-model="$v.form.termina_em.$model")
          form-group.column.col-12(:label="'cadastro_protegido.descricao' | tModel" :validation="$v.form.descricao")
            input.form-input(v-model="$v.form.descricao.$model" type="text")
          form-group.column.col-3.col-sm-12(:label="'cadastro_protegido.protocolo_numero' | tModel" :validation="$v.form.protocolo_numero")
            int.form-input(v-model="$v.form.protocolo_numero.$model")
          form-group.column.col-3.col-sm-12(:label="'cadastro_protegido.protocolo_ano' | tModel" :validation="$v.form.protocolo_ano")
            year.form-input(v-model="$v.form.protocolo_ano.$model")
        .panel-footer.text-right
          button.btn.btn-primary(:disabled="$v.$invalid || loading" :class="loading") Salvar
</template>

<script>
import { deepClone, sanitize } from "paliari-js-utils"
import { required } from "vuelidate/lib/validators"
import toastErrors from "@/lib/errors/toastErrors"

export default {
  vuex: {
    cadastroProtegidos: {
      state: ["current", "status"],
      getters: ["loading"],
      actions: ["fetchUpdate", "fetchOne"],
    },
  },
  data() {
    return {
      form: {
        doc_modelo_id: null,
        inicia_em: null,
        termina_em: null,
        protocolo_numero: 0,
        protocolo_ano: 0,
        descricao: "",
      },
    }
  },
  methods: {
    async save() {
      try {
        await this.fetchUpdate(this.form)
        this.$toaster.success("Salvo com sucesso")
        this.$router.replace({ name: "app.cadastroProtegidos" })
      } catch (e) {
        toastErrors(e)
      }
    },
  },
  async created() {
    await this.fetchOne(this.$route.params.id)
    const rules = {
      id: true,
      cadastro_id: true,
      doc_modelo_id: true,
      inicia_em: true,
      termina_em: true,
      protocolo_numero: true,
      protocolo_ano: true,
      descricao: true,
    }
    this.form = sanitize(deepClone(this.current), rules)
  },
  validations() {
    return {
      form: {
        cadastro_id: { required },
        doc_modelo_id: { required },
        descricao: { required },
        protocolo_numero: {},
        protocolo_ano: {},
        inicia_em: { required },
        termina_em: {},
      },
    }
  },
}
</script>
